import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { FormGroup, FormArray, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../../../models/usuario';
import { AuthService } from '../../admin/auth.service';
import { StatusControleLancamento } from '../../../models/statusControleLancamento';
import { FinanceiroService } from '../financeiro.service';
import { isDefaultChangeDetectionStrategy } from '@angular/core/src/change_detection/constants';

@Component({
  selector: 'sispac-enviar-prestacao-analise',
  templateUrl: './enviar-prestacao-analise.component.html',
  styleUrls: ['./enviar-prestacao-analise.component.css']
})
export class EnviarPrestacaoAnaliseComponent extends WebPage implements OnInit {
  public idControleLancamento: string;
  public uploadUrl;
  public form: FormGroup;
  public arquivosToRemove = new FormArray([]);
  public usuario: Usuario;
  public isSubmitted = false;


  get arquivos() { return this.form.get('arquivos') as FormArray; }

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private _financeiroService: FinanceiroService,
    private arquivoService: ArquivoService,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idControleLancamento = params.get('id');
      }
    });
    this.uploadUrl = this.arquivoService.uploadUrl + 'comprovanteDetran';
    this.usuario = this.authService.informacoesUsuario();
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      idControleLancamento: [null, Validators.required],
      idUnidade: [null, Validators.required],
      idStatusControleLancamento: [null, Validators.required],
      idUsuarioGestaoSS: [null, Validators.required],
      idArquivoAnalise: [null, Validators.required],
      arquivos: new FormArray([]),
    });
  }
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;
    // console.log(idArquivo);
    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
    this.arquivosToRemove.push(arquivoFormGroup);

    this.form.patchValue({ idArquivoAnalise: idArquivo });
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }

  removeArquivo(arquivo: AbstractControl) {

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        // console.log(arquivo);
        const index = this.arquivos.controls.indexOf(arquivo);
        this.arquivos.removeAt(index);

        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld);
        // console.log('arquivos novos - removeArquivo', arquivosNovos);

        this.removeArquivosDoBanco(arquivosNovos);
      },
      reject: () => {
        // this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        // console.log(this.arquivosToRemove);
        if (this.arquivosToRemove.controls.length > 0) {
          let arquivosNovos: AbstractControl[];
          arquivosNovos = this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld);
          this.removeArquivosDoBanco(arquivosNovos);
        }
        this.router.navigate(['/gerenciar-prestacao-contas']);
      }
    });
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {
          // this.isLoading = false;
          this.arquivosToRemove = new FormArray([]);
        },
        error => this.gerenciaErro(error)
      );
  }

  removeArquivoById(id: string) {
    this.isLoading = true;
    const combined = this.arquivoService.removeArquivo(id);
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {
          // this.isLoading = false;
          this.arquivosToRemove.reset();
        },
        error => this.gerenciaErro(error)
      );
  }

  downloadArquivo(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Documento_Laboratorio');
  }

  submit() {
    this.isSubmitted = true;

    this.form.patchValue({
      idControleLancamento: this.idControleLancamento,
      idUsuarioGestaoSS: this.usuario.IdUsuario,
      idUnidade: this.usuario.IdUnidade,
      idStatusControleLancamento: StatusControleLancamento.IdEnviadoAnalise
    });

    if (this.form.valid) {
      this.confirmationService.confirm({
        message: 'Deseja mesmo salvar este registro?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this._financeiroService.alterarControleLancamento(this.form.value)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.router.navigate(['/gerenciar-prestacao-contas']);
              },
              error => {
                this.isSubmitted = false;
                this.gerenciaErro(error);

              }
            );
        },
        reject: () => {
          // this.isLoading = false;
          this.isSubmitted = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });
    } else {
      this.isSubmitted = false;
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchidos!' });

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/enviar-prestacao-analise/enviar-prestacao-analise.component.ts